<template>

  <div class="list row">
        <span v-touch:swipe.left="swipeLeft" v-touch:swipe.right="swipeRight">
        <div class="col-md-10">
            <div>
                <h5>
                    {{ seasonHeader }} -
                    <font-awesome-icon @click="decreaseMatchDay" icon="angle-left"/>
                    {{ matchDayHeader }}. Spieltag
                    <font-awesome-icon @click="increaseMatchDay" icon="angle-right"/>
                </h5>
            </div>
            <ul class="list-group">
                <li class="list-group-item"
                    v-for="(match, index) in matches"
                    :key="index"
                    :class="{ highlight: match.isHighlight }"
                    @click="!isPassedTimeLimit() && setActiveMatch(match, index)">

                    <div v-responsive.md.lg.xl>
                        <img width="20px" heigth="20px" :src="match.homeTeamImage">
                        {{ match.homeTeam }} - {{ match.guestTeam }}
                        <img width="20px" heigth="20px" :src="match.guestTeamImage">
                        <br/>
                        {{ formatDate(match.matchDate) }}
                    </div>
                    <div v-responsive.sm.xs>
                        <img width="20px" heigth="20px" :src="match.homeTeamImage">
                        {{ match.homeTeamShort }} - {{ match.guestTeamShort }}
                        <img width="20px" heigth="20px" :src="match.guestTeamImage">
                        <br/>
                        {{ formatDate(match.matchDate) }}
                    </div>
                </li>
            </ul>

        </div>
        <back-to-top text="Nach oben"></back-to-top>
        </span>
  </div>

</template>

<script>
import MatchDataService from "../services/match-data.service"

export default {
  name: "match-list",
  data() {
    return {
      matches: [],
      currentMatch: null,
      currentIndex: -1,
      currentSelectedMatchDayNumber: this.currentMatchDayNumber,
      seasonHeader: "",
      matchDayHeader: "",
      ready: false
    }
  },
  computed: {
    currentSeasonYear() {
      return this.$store.state.sys.seasonYear;
    },
    currentMatchDayNumber() {
      return this.$store.state.sys.matchDay;
    }

  },
  methods: {
    retrieveMatches() {
      let data = {
        day: this.currentSelectedMatchDayNumber,
        season: this.currentSeasonYear
      }
      MatchDataService.getAllMatches(data)
          .then(response => {
            console.log(JSON.stringify(response.data));
            this.matches = response.data;
            this.seasonHeader = this.matches[0].matchDay.season;
            this.matchDayHeader = this.matches[0].matchDay.matchDayNumber;
            this.ready = true;
          })
          .catch(err => {
            console.log(err);
          });
    },
    refreshList() {
      this.ready = false;
      this.retrieveMatches();
      this.currentMatch = null;
      this.currentIndex = -1;
    },
    isPassedTimeLimit() {
      console.log("========================>>" + this.matches[0].matchDate);
      if (new Date(this.matches[0].matchDate) < Date.now()) {
        return true;
      } else {
        return false;
      }
    },
    setActiveMatch(match, index) {

      this.$confirm({
        message: "Soll das ausgewählte Spiel als Topspiel definiert werden?",
        button: {
          no: 'Nein',
          yes: 'Ja'
        },
        callback: confirm => {
          if (confirm) {
            match.isHighlight = true;
            MatchDataService.saveMatch(match)
                .then(result => {
                  console.log(result);
                  this.retrieveMatches();
                  this.currentMatch = match;
                  this.currentIndex = index;
                })
                .catch(err => {
                  console.log(err);
                });
          }
        }
      });
    },
    formatDate(date) {
      return MatchDataService.formatDate(date);
    },
    increaseMatchDay() {
      if (this.currentSelectedMatchDayNumber === 34) {
        return;
      }
      this.currentSelectedMatchDayNumber += 1;
      this.retrieveMatches();
    },
    decreaseMatchDay() {
      if (this.currentSelectedMatchDayNumber === 1) {
        return;
      }
      this.currentSelectedMatchDayNumber -= 1;
      this.retrieveMatches();
    },
    swipeLeft() {
      this.increaseMatchDay();
    },
    swipeRight() {
      this.decreaseMatchDay();
    },
    isHighlight(match) {
      return match.isHighlight === true;
    }
  },
  mounted() {
    this.$store.dispatch('sys/getCurrentMatchDay')
    .then(() => {
      return this.$store.dispatch('sys/getCurrentSeasonYear');
    })
    .then(() => {
      if(this.currentMatchDayNumber == undefined){
        this.currentSelectedMatchDayNumber = 1;
      } else {
        this.currentSelectedMatchDayNumber = this.currentMatchDayNumber;
      }
      this.retrieveMatches();
    })
  }
}
</script>

<style>
.list {
  text-align: left;
  max-width: 750px;
  margin: auto;
}

.highlight {
  background-color: greenyellow;
}
</style>